import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class NotFound extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div>
        404
      </div>
    );
  }
}

export default NotFound;
